// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__36BEV","content":"styles_content__3T5-5","selectAll":"styles_selectAll__33oUO"};